// 客室詳細
const html = document.querySelector('html');

// Room Layout
const roomLowerLayoutModalOpen = document.querySelector('#modal-layout__open');
const roomLowerLayoutModalClose = document.querySelector('.modal-layout__close-label');
const roomLowerLayoutModalClose2 = document.querySelector('.modal-layout__background');

if(roomLowerLayoutModalOpen) {
  roomLowerLayoutModalOpen.addEventListener('click', () => {
    html.style.overflow = 'hidden';
  })
}
if(roomLowerLayoutModalClose){
  roomLowerLayoutModalClose.addEventListener('click', () => {
    html.style.overflow = '';
  })
}
if(roomLowerLayoutModalClose2){
  roomLowerLayoutModalClose2.addEventListener('click', () => {
    html.style.overflow = '';
  })
}

// AMENITY
const roomLowerAmenityModalOpen = document.querySelector('#modal-amenity__open');
const roomLowerAmenityModalClose = document.querySelector('.modal-amenity__close-button');
const roomLowerAmenityModalClose2 = document.querySelector('.modal-amenity__close-label');

if(roomLowerAmenityModalOpen) {
  roomLowerAmenityModalOpen.addEventListener('click', () => {
    html.style.overflow = 'hidden';
  })
}
if(roomLowerAmenityModalClose){
  roomLowerAmenityModalClose.addEventListener('click', () => {
    html.style.overflow = '';
  })
}
if(roomLowerAmenityModalClose2){
  roomLowerAmenityModalClose2.addEventListener('click', () => {
    html.style.overflow = '';
  })
}

// RENTAL AMENITY
const roomLowerRentalAmenityModalOpen = document.querySelector('#modal-rental-amenity__open');
const roomLowerRentalAmenityModalClose = document.querySelector('.modal-rental-amenity__close-button');
const roomLowerRentalAmenityModalClose2 = document.querySelector('.modal-rental-amenity__close-label');

if(roomLowerRentalAmenityModalOpen) {
  roomLowerRentalAmenityModalOpen.addEventListener('click', () => {
    html.style.overflow = 'hidden';
  })
}
if(roomLowerRentalAmenityModalClose){
  roomLowerRentalAmenityModalClose.addEventListener('click', () => {
    html.style.overflow = '';
  })
}
if(roomLowerRentalAmenityModalClose2){
  roomLowerRentalAmenityModalClose2.addEventListener('click', () => {
    html.style.overflow = '';
  })
}

